<template>
  <div class="container" :style="{ height: windowHeight }">
    <div class="box">
      <van-cell-group class="margin el">
        <van-field
          label-width="60px"
          v-model="voucherNumber"
          ref="number"
          label="卡券编码"
          placeholder="请输入卡券编码"
        >
          <template #right-icon>
            <van-icon name="scan" size="25" @click="scan"/>
          </template>
        </van-field>
      </van-cell-group>
      <JcRange
        class="margin el"
        :confirmSuccess.sync="verificationState"
      ></JcRange>
      <van-button
        class="margin"
        style="width: 80%"
        @click="search"
        round
        type="info"
        >立即查询</van-button
      >
    </div>
  </div>
</template>


<script>
import wx from "weixin-js-sdk";
import JcRange from "@/components/jcRange/jcRange.vue";
import api from "../../common/js/api";
export default {
  data() {
    return {
      verificationState: false, //滑块验证状态
      voucherNumber: "", //卡券编码
      windowHeight: document.documentElement.clientHeight + "px", //实时屏幕高度
    };
  },

  components: {
    JcRange,
  },

  computed: {},

  mounted() {},

  methods: {
    search() {
      if (this.voucherNumber == "") {
        this.$toast("请输入卡券编码");
      }
      //验证滑块状态
      else if (this.verificationState) {
        this.$post(api.getByCardNo, { cardNo: this.voucherNumber }).then(
          (res) => {
            console.log(res);
            if (res.success) {
              //status=1，表示未绑卡，=2表示已经绑卡，=3表示已经领取
              if (res.data.status != 1) {
                this.$router.push({
                  path: "/searchResult",
                  query: { voucherCode: this.voucherNumber },
                });
              } else {
                this.$toast(res.message);
              }
            } else {
              this.$toast(res.message);
            }
          }
        );
      } else {
        this.$toast("请完成滑动验证");
      }
    },
    scan(){
      // this.$router.push("/loginScanner");
      wx.ready(function () {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维，默认二者都有
          success: function (res) {
            window.location.href=res.resultStr;
          },
        });
      });
    }
  },
};
</script>
<style lang='scss' scoped>
.container {
  background-image: url(../../common/img/background.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  .box {
    border-radius: 5%;
    position: absolute;
    background-color: rgba(119, 136, 153, 0.3);
    width: 80%;
    top: 30%;
    left: 10%;
    .el {
      width: 80%;
      left: 10%;
    }
  }
}
.margin {
  margin: 20px 0 20px 0;
}
</style>